"use client";

import { useUser } from "@clerk/nextjs";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import { canOpenOnboardingOnPathname } from "@/hooks/onboarding-url";

const OnboardingDialog = dynamic(
  () => import("@/components/onboarding/OnBoardingDialog")
);

export default function OnboardingDialogLoader() {
  const { isSignedIn } = useUser();
  const pathname = usePathname();

  if (!isSignedIn || !canOpenOnboardingOnPathname(pathname)) {
    return null;
  }

  return <OnboardingDialog />;
}
